import { Component, OnDestroy } from "@angular/core";
import { ResolveEnd, ResolveStart, Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { NgcCookieConsentService } from "ngx-cookieconsent";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { UtilService } from "src/app/services/util/util.service";

@Component({
  selector: "via-record-interview",
  templateUrl: "./record-interview.component.html",
  styleUrls: ["./record-interview.component.scss"],
})
export class RecordInterviewComponent implements OnDestroy {
  resolveLoader = false;

  private readonly networkStateSubscription$: Subscription;
  constructor(
    private _router: Router,
    private _util: UtilService,
    private _cookieConsent: NgcCookieConsentService,
    private _translate: TranslocoService
  ) {
    this._util.registerNetworkHandler();
    this.networkStateSubscription$ =
      this._util.networkStateSubject$.subscribe();
    this._router.events
      .pipe(filter((e) => e instanceof ResolveStart || e instanceof ResolveEnd))
      .subscribe((e) => {
        if (e instanceof ResolveStart) {
          this.resolveLoader = true;
        }
        if (e instanceof ResolveEnd) {
          this.resolveLoader = false;
        }
      });

    this._cookieConsent.destroy();
    this._translate.events$
      .pipe(filter((e) => e.type === "translationLoadSuccess"))
      .subscribe(() => {
        const message = this._translate.translate("cookieconsent.message");
        const dismiss = this._translate.translate("cookieconsent.dismiss");
        const cookiePolicyLink = this._translate.translate(
          "cookieconsent.cookiePolicyLink"
        );
        this._cookieConsent.getConfig().content = {
          ...(this._cookieConsent.getConfig().content ?? {}),
          ...{
            message,
            dismiss,
            cookiePolicyLink,
          },
        };

        this._cookieConsent.init(this._cookieConsent.getConfig());
      });
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.networkStateSubscription$.unsubscribe();
  }
}
